<template>
  <ion-page>
    <ion-header >
      <ion-toolbar>
        <ion-title>{{ title || name }}</ion-title>
        <ion-back-button slot="start" text="Voltar" color="medium" @click="backButton()"/>
        <!-- <ion-buttons slot="start">
          <ion-back-button/>
        </ion-buttons> -->
        <ion-buttons v-if="false" slot="end">
          <ion-button :color="computedHasFiltersApplied ? 'warning' : ''" @click="showPopOver(true, $event)">
            <ion-icon slot="icon-only" :icon="menu"></ion-icon>
          </ion-button>
          <ion-popover
            :is-open="isPopOverRef"
            :event="event"
            @didDismiss="showPopOver(false)">
              <ion-list class="ion-no-padding">
                <!-- <ion-item button @click="()=>{exportXlsx({dTable: computedDataTables[0]}); showPopOver(false)}">
                  <ion-label>Exportar Excel</ion-label>
                  <ion-icon :icon="downloadOutline"></ion-icon>
                </ion-item> -->
                
                <ion-item button @click="() => {isOpenRef = true; showPopOver(false)}">
                  <ion-label>Filtros</ion-label>
                  <ion-icon :icon="funnelOutline"></ion-icon>
                </ion-item>
              </ion-list>
          </ion-popover>
        </ion-buttons>
      </ion-toolbar>

      <template v-for="(dTable, index) of computedDataTables" :key="index">
        <ion-toolbar v-if="dTable.headers.some((x) => x.searchable) || computedFiltersAsync && computedFiltersAsync.length || props.mobileInline" >
          <v-text-field-external
            v-if="dTable.headers.some((x) => x.searchable)"
            v-model="searchInputs[dTable.register]"
            :externalRequest="dTable.externalRequest"
            :handler="search"
            :delay="750"
            :filtersIn="computedFiltersProcessed"
            :fieldsToSearch="dTable.headers.filter((x) => x.searchable).map((x) => x.searchableContent || x.value)"
            :fieldsToMark="dTable.headers.filter((x) => x.searchable && x.searchableContent).map(({searchableContent, value}) => ({ searchableContent, value }))"
            :register="`report${dTable.register}`"
            :ref="`externalSearchInput${dTable.register}`"/>

          <template v-if="computedFiltersAsync && computedFiltersAsync.length">
            <ion-button 
              @click="openFilter = true"
              size="small"
              shape="round" 
              expand="full"
              fill="solid"
              :color="isFiltered ? 'success' : 'medium'"
              :style="{margin: '5px', height: '30px'}"
              >
              <ion-icon size="small" :icon="filterOutline" :style="{marginRight: '5px'}"></ion-icon>
              Filtros
            </ion-button>
            <ion-modal :is-open="openFilter">
              <DataTableFilters
                ref="DataTableFilters"
                :filtersProps="computedFiltersAsync"
                :filtersMounted="filtersMounted"
                @cancelFilters="openFilter = false"
                v-on:change="updateAsyncFilter"
              />
            </ion-modal>
          </template>

          <template>       
            <ion-modal :is-open="isOpenRef" @didDismiss="setOpen(false)">
              <ion-page>
                <ion-header>
                  <ion-toolbar>
                    <ion-title :style="{marginStart: '16px'}">Filtros</ion-title>
                    <ion-buttons slot="end">
                      <ion-button @click="setOpen(false)">
                        <ion-icon slot="icon-only" :icon="close"></ion-icon>
                      </ion-button>
                    </ion-buttons>
                  </ion-toolbar>
                </ion-header>
                <ion-content>
                  <ion-list>
                    <template v-for="(dTable, index) of computedDataTables" :key="index">
                      <template v-for="(key, index) of filtersProcessed" :key="index">
                        <ion-item>
                          <ion-label>{{key.text}}</ion-label>
                          <ion-select v-model="key.selecteds" :multiple="key.multiple"  @ionChange="applyFilter()">
                            <template v-for="(item, index) of searchInFilters[key.field] && searchInFilters[key.field].length > 0 ?
                              registers[`reportFilters${key.field}Filtered`] :
                              registers[`reportFilters${key.field}`]" :key="index">
                              <ion-select-option 
                                :value="item[key.itemValue]"
                                :ref="`reportFiltersSelect${key.field}`">
                                {{item[key.itemText]}}
                              </ion-select-option>
                            </template>
                          </ion-select>
                        </ion-item>
                      </template>
                    </template>
                  </ion-list>
                </ion-content>
              </ion-page>
            </ion-modal>
          </template>
                   
          <ion-card v-if="props.mobileInline" class="card-purchases" :style="{ margin: '5px 5px 0 5px', background: 'transparent', boxShadow: 'none' }">
            <ion-card-header :style="{ padding: '2px 0' }">
              <ion-row :style="{marginBottom: '5px'}">
                <ion-col v-for="head in headers.map(x => x.text)" :key="`title-${head}`" :style="{padding: '0', height: '12px'}">
                  <ion-title :style="{fontSize: '0.9em', textAlign: 'center'}">{{ head }}</ion-title>
                </ion-col>
              </ion-row>
            </ion-card-header>
          </ion-card>
        </ion-toolbar>
        <ion-accordion-group v-if="dTable.charts && dTable.charts.length > 0 && totalize && computedKpiCharts && computedKpiCharts[dTable.register]">
          <ion-accordion value="first">
            <ion-item slot="header">
              <ion-label>
                <ion-icon :icon="pieChartOutline"></ion-icon> Gráficos
              </ion-label>
            </ion-item>

            <div slot="content">
              <BulletBar v-if="totalize && computedMetaTotal" 
                :valueTotal="computedMetaTotal"
                :value="computedValorVendido"
              />
              <ion-row>
                <ion-col size="6">
                  <KPIs
                    v-if="
                      computedKpiCharts &&
                      computedKpiCharts[dTable.register] &&
                      computedKpiCharts[dTable.register]['metaTotal']
                    "
                    :title="
                      computedKpiCharts[dTable.register]['metaTotal']['title']
                    "
                    :kpi="
                      computedKpiCharts[dTable.register]['metaTotal']['value']
                    "
                  />
                </ion-col>
                <ion-col size="6">
                  <KPIs
                    v-if="
                      computedKpiCharts &&
                      computedKpiCharts[dTable.register] &&
                      computedKpiCharts[dTable.register]['valorTotal']
                    "
                    :title="
                      computedKpiCharts[dTable.register]['valorTotal']['title']
                    "
                    :kpi="
                      computedKpiCharts[dTable.register]['valorTotal']['value']
                    "
                  />
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="6">
                  <KPIs
                    v-if="
                      computedKpiCharts &&
                      computedKpiCharts[dTable.register] &&
                      computedKpiCharts[dTable.register]['performance']
                    "
                    :title="
                      computedKpiCharts[dTable.register]['performance']['title']
                    "
                    :kpi="
                      computedKpiCharts[dTable.register]['performance']['value']
                    "
                  />
                </ion-col>
                <ion-col size="6">
                  <KPIs
                    v-if="
                      computedKpiCharts &&
                      computedKpiCharts[dTable.register] &&
                      computedKpiCharts[dTable.register]['saldoTotal']
                    "
                    :title="
                      computedKpiCharts[dTable.register]['saldoTotal']['title']
                    "
                    :kpi="
                      computedKpiCharts[dTable.register]['saldoTotal']['value']
                    "
                  />
                </ion-col>
              </ion-row>
            </div>
            
          </ion-accordion>
        </ion-accordion-group>
      </template>
    </ion-header>

    <ion-row v-if="computedHasFiltersApplied" class="filters-applied">
      <ion-col size="12">
        <ion-button color="warning" size="small" expand="full">
          <ion-icon :icon="funnelOutline"></ion-icon>&nbsp; Filtros aplicados! 
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-content>
      <template v-if="items && items.length > 0">
        <ion-card v-if="props.mobileInline" class="card-purchases" :style="{ margin: '5px' }">
          <ion-card-header :style="{ padding: '8px' }">
            <ion-grid class="ion-no-padding">
              <template v-for="(dTable, index) of computedDataTables" :key="index">
                <template v-for="(item, index) of items" :key="index">
                  <ion-row class="row-margin-bottom header">
                    <ion-col v-for="(head, index) of getProcessedHeaders({dTable, level: 1})" :key="index" :style="{ textAlign: 'center' }" >
                      <small v-html="proccessItem({item, head})"></small>
                    </ion-col>
                    <hr :style="{ height: '.25px', width: '100%', margin: '4px 0' }" color="grey" />
                  </ion-row>
                </template>
              </template>
            </ion-grid>
          </ion-card-header>
        </ion-card>
  
        <ion-list v-else :style="{padding: '8px 8px 0 8px', background: 'transparent'}">
          <template v-for="(dTable, index) of computedDataTables" :key="index">
              <template v-for="(item, index) of items" :key="index">
  
                <ion-card style="margin-bottom: 8px;">
                  <ion-card-content>
                    <ion-grid class="ion-no-padding">
                      <template v-for="(head, index) of getProcessedHeaders({dTable, level: 1})" :key="index">
                        <ion-row class="ion-align-items-center" :style="{borderBottom: '1px solid grey'}">
                          <ion-col size="3">
                            <small>{{head.text}}</small>
                          </ion-col>
                          <ion-col size="9">
                            <small v-html="proccessItem({item, head})"></small>
                          </ion-col>
                        </ion-row>
                      </template>
                    </ion-grid>
                  </ion-card-content>
                </ion-card>
              </template>
              
              <!-- <template v-if="!loading[`report${dTable.register}`] && computedEmptyRegisters && computedEmptyRegisters[dTable.register]">
                <ion-card class="empty-data-table">
                  <ion-card-content>
                    <ion-icon :icon="sadOutline" />
                    Nenhum registro encontrado
                  </ion-card-content>
                </ion-card>
              </template> -->
          </template>
        </ion-list>
      </template>

      <!-- Loading -->
      <ion-grid v-if="loadingAsync" :style="{height: '50%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <ion-label>Buscando itens</ion-label>
            <br/>
            <ion-spinner name="dots"></ion-spinner>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- No Data -->
      <ion-grid v-else-if="items && items.length == 0" :style="{height: '50%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <ion-label color="danger" v-if="isSearched">A pesquisa por "<strong>{{ search.value }}</strong>" não retornou registros, confira os filtros selecionados.</ion-label>
            <ion-label color="danger" v-else-if="isFiltered">Os filtros selecionados não retornaram registros.</ion-label>
            <ion-label color="danger" v-else>Sem registros.</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- Scroll Next -->
      <ion-infinite-scroll
        @ionInfinite="loadMore($event)"
        threshold="100px"
        id="infinite-scroll"
        ref="infiniteScroll"
        :style="{marginTop: '40px'}"
        :disabled="disabledScroll">
        <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Buscando mais dados...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>

    <ion-footer v-if="props.queryTotalize" class="ion-no-padding ion-no-margin ion-footer-totalize" style="background-color: #ffffff66">
      <ion-card class="ion-no-padding" :style="{ margin: '2px'}">
        <ion-card-header class="ion-no-padding ion-no-margin" :style="{ padding: '8px' }">
          <ion-grid class="ion-no-padding">
            <ion-row class="row-margin-bottom ion-text-center">
              <b class="ion-text-center" :style="{width: '100%'}">
                Totais  
              </b>              
            </ion-row>
            <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
           
            <!-- Loading -->
            <ion-row v-if="!totalize" class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
              <ion-col size="12">
                <ion-spinner name="dots"></ion-spinner>
              </ion-col>
            </ion-row>
            <ion-list mode="ios" class="ion-no-padding ion-no-margin">
              <ion-item lines="full" v-for="(total, index) of totalize" :key="index" class="ion-no-padding ion-no-margin">
                <ion-card-subtitle>{{ total.label }}</ion-card-subtitle>                  
                <ion-label class="ion-text-end">{{ total.text }}</ion-label>                  
              </ion-item>
            </ion-list>
          </ion-grid>
        </ion-card-header>
      </ion-card>
    </ion-footer>
  </ion-page>
</template>

<script>
import DataTableFilters from "@/components/DataTableFilters.vue"
import {
  IonAccordionGroup,  
  IonAccordion,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonBackButton,
  IonContent,
  IonList,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButtons,
  IonButton,
  IonIcon,
  IonModal,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonPopover,
  IonFooter,
  IonSpinner,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonCardSubtitle,
} from '@ionic/vue'
import store from '../../store'
import { ref } from 'vue'
import { filterOutline, funnelOutline, menu, close, settingsOutline, ellipsisVertical, downloadOutline, sadOutline, pieChartOutline } from 'ionicons/icons'
import {createNamespacedHelpers, mapMutations, mapState} from "vuex"
import KPIs from '../../components/Charts/KPIs'
import BulletBar from '../../components/Charts/BulletBar'
import VTextFieldExternal from '../../components/VTextFieldExternal.vue'
import XLSX from "xlsx"

const { mapState: registersState, mapActions: registersActions } = createNamespacedHelpers("registers")
const { mapState: authState } = createNamespacedHelpers("auth");

export default {
  name: "GeneratedReportsRegister",
  components:{
    BulletBar,
    DataTableFilters,
    KPIs,
    IonAccordionGroup,
    IonAccordion,
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonBackButton,
    IonContent,
    IonList,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButtons,
    IonButton,
    IonIcon,
    IonModal,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonPopover,
    VTextFieldExternal,
    IonFooter,
    IonSpinner,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonCardSubtitle
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isRestNode: {
      type: Boolean,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    dataTables: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: false
    }
  },
  watch: {
    dataCounter(){
      if((this.dataTables.length + this.filters.length) === this.dataCounter) {
        this.setLoading({stats: false})
      } else {
        this.setLoading({stats: false})
      }
    }
  },
  data() {
    return {
      openFilter: false,
      filtersMounted: [],
      filtersAsyncModelsData: {},
      searchInput: {
        value: ''
      },
      loadingAsync: false,
      dialog: false,
      dataTablesProcessed: [],
      filtersProcessed: [],
      searchInFilters: {},
      searchInputs: {},
      searchEnableds: {},
      configsShowed: {},
      headersShowed: {},
      dataCounter: 0,
      totalize: null,
      externalRequest: {},
      disabledScroll: false
    };
  },
  methods: {
    ...registersActions(["getExternal", "showToast"]),
    ...mapMutations(['setLoading']),    
    updateAsyncFilter({filters, filtersMounted}) {
      this.getData({filters})
      this.filtersMounted = filtersMounted
      this.openFilter = false
    },
    async backButton() {
      store.$router.back();
    },
    getProcessedHeaders({dTable, level}) {
      return dTable.headers
        .filter(h => 
          h.showable && 
          this.computedHeadersShowed[dTable.register][h.value] && 
          (
            !dTable.headers.some(h => h.groupLevels && h.groupLevels.length > 0)
            || (
              h.groupLevels?.includes(level) ||
              h.typeReduce
            )
          )
        )
        .map(h => {
          if (h.text.includes('${')) {
            h.text = eval(h.text)
          }
          return h
        })

    },
    proccessItem({item, head}) {
      let ret = store.$_.cloneDeep(item);
      if (!ret) return;
      if (
        ret._highlightResult && 
        ret._highlightResult[head.value] && 
        ret._highlightResult[head.value].matchedWords && 
        ret._highlightResult[head.value].matchedWords.length > 0
      ) {
        ret = ret._highlightResult;
      }
      /* NESTED */

      const pathItem = head.value.split(".");
      const lenItem = pathItem.length;
      if (lenItem == 1) {
        ret = ret[pathItem];
      } else {
        for (let ix = 0; ix < pathItem.length; ix++) {
          const el = pathItem[ix];
          if (ret && typeof ret[el] != "undefined") {
            ret = ret[el];
          } else {
            ret = head.checkbox ? false : "";
            break;
          }
        }
      }

      /* FORMATS */
      if (!ret && ret !== 0) return;
      if (ret && ret.value) ret = ret.value;
      if (head.upper) {
        ret = ret.toUpperCase();
      }
      if (head.lower) {
        ret = ret.toLowerCase();
      }
      if (head.trim) {
        ret = ret.trim();
      }
      
      /* FORMAT DATES */
      if (head.type === "date" || head.type === "dateHour" || head.type === "dateYear" || head.type === "datePlusWeek") {
        if (Object.prototype.hasOwnProperty.call(ret, "toDate")) {
          ret = ret.toDate();
        } else if (ret.seconds && ret.nanoseconds) {
          // Retorno via Algolia não contem metodo toDate (agora o firebase tbm)
          ret = new this.$db.Timestamp(ret.seconds, ret.nanoseconds).toDate();
          // Retorno via Algolia não contem metodo toDate. (agora tem o underline na frente)
        } else if (ret._seconds && ret._nanoseconds) {
          ret = new this.$db.Timestamp(ret._seconds, ret._nanoseconds).toDate();
        }
      }
      if (head.type === "date") {
        ret = store.$moment(ret).format("DD/MM/YYYY");
      }
      if (head.type === "dateHour") {
        ret = store.$moment(ret).format("DD/MM/YYYY - HH:mm:ss");
      }
      if (head.type === "dateYear") {
        ret = store.$moment(ret).format("YYYY");
      }
      if (head.type === "datePlusWeek") {
        ret = store.$moment(ret).format("DD/MM/YYYY, dddd");
      }

      if (head.type === "money") ret = new Intl.NumberFormat("pt-BR", {style: "currency", currency: "BRL"}).format(ret);
      if (head.type === "percent") ret = new Intl.NumberFormat("pt-BR", {style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((ret/100));

      // if (options.slice) { obj = (obj) ? obj.slice(options.slice) : '' }
      // if (options.multiplier) { obj = (obj) ? obj * options.multiplier : '' }

      return ret;
    },
    getData({filters = []} = {}) {
      this.setLoading({stats: true, message: "Montando relatório"});
      this.loadingAsync = true
      this.disabledScroll = false
     
      const {query, queryTotalize, fieldsTotalize, register, headers, order = {by: 'ID', desc: false}, itemsPerPage: perPage = 10} = this.props;
      const ordem = `${order.by} ${order.desc ? 'DESC' : 'ASC'}`
      this.externalRequest = {query, idField: "ID", register: `report${register}`, ordem, filters, page: 1, perPage: 50, async: true, completeRes: true, isRestNode: this.isRestNode}
      const totalizeRequest = {query: queryTotalize, register: `report${register}_totalize`, filters, ordem: 'ID ASC', perPage: 1, async: true, setRegister: false, isRestNode: this.isRestNode}

      this.getExternal(this.externalRequest)
        .then(res => { 
          this.dataCounter++
          if (!res || !res.PROXIMO) { this.disabledScroll = true } 
        })
        .catch(err => this.disabledScroll = true)
        .finally(() => this.loadingAsync = false)

      if (queryTotalize) {
        this.totalize = null;
        this.getExternal(totalizeRequest).then((res)=>{
          if (res && res.length > 0) {
            this.totalize = []
            for (const field of fieldsTotalize) {
              const totalize = res[0]
              const value = totalize[field.value]
              this.totalize.push({
                label: field.text,
                text: this.proccessItem({item: totalize, head: field}),
                value: totalize[field.value]
              });
            }
          }
        })
      }
    },
    initRegisters() {
      if (this.computedFiltersAsync && this.computedFiltersAsync.length > 0) {
        const hasDefaults = this.computedFiltersAsync.some(x => x.default)
        if (hasDefaults) {
          for (const filter of this.computedFiltersAsync) {
            if (filter.default) {
              let def = filter.default
              if (filter.range) {
                const days = parseInt(def)
                let today = new Date();
                let before = new Date();
                before.setDate(before.getDate() - days);
                today = today.toLocaleString()
                before = before.toLocaleString()
                def = [before.substring(0, 10).split('/').reverse().join(''), today.substring(0, 10).split('/').reverse().join('')]
              }
              if (def) { this.filtersMounted[filter.value] = def }
            }
          }
          this.openFilter = true
        } else {
          this.getData()
        }
      } else {
        this.getData()
      }

      this.dataTablesProcessed = this.dataTables.map((dTable) => {
        const {query, queryTotalize, fieldsTotalize, register, filters = [], headers, order = {by: 'ID', desc: false}, itemsPerPage: perPage = 10} = dTable;
        const ordem = `${order.by} ${order.desc ? 'DESC' : 'ASC'}`
        this.externalRequest = {query, idField: "ID", register: `report${register}`, ordem, page: 1, perPage: 50, async: true, completeRes: true, isRestNode: this.isRestNode}

        return {...dTable, filters, serverItemsLength: true, externalRequest: this.externalRequest};
      });

      this.filtersProcessed = this.filters.map((f, ix) => {
        const { query, itemValue: idField, itemText: ordem } = f
        const externalRequest = {query, idField, register: `reportFilters${f.field}`, ordem, perPage: 999999999, isRestNode: this.isRestNode }
        this.getExternal(externalRequest).then(()=>{
          this.dataCounter++
        })
        return {...f, data: [], selecteds: [], externalRequest}
      })
    },
    loadMore(event) {
      this.externalRequest.page += 1
      this.externalRequest.nextPage = true
      this.getExternal(this.externalRequest)
        .then(res => { 
          if (!res || !res.PROXIMO) { this.disabledScroll = true } 
        })
        .catch(err => this.disabledScroll = true)
        .finally(() => event.target.complete())

    },
    async search(req) {
      try {
        await req;
      } catch (err) {
        console.error(err);
      }
    },
    applyFilter() {
      this.computedDataTables.forEach(dTable => {
        const { query, register, order = {by: 'ID', desc: false}, page = 1 } = dTable
        const input = `externalSearchInput${register}`
        const filtersIn = [...this.computedFiltersProcessed.filter(f => f.selecteds.length > 0)]
        
        if (this.$refs[input] && 'search' in this.$refs[input] && typeof this.$refs[input].search === 'function') {
          this.$refs[input].search(this.searchInputs[register], [], filtersIn)
        } else  {
          const ordem = `${order.by} ${order.by && order.desc ? 'DESC' : ''}`
          const externalRequest = { query, idField: "ID", register: `report${register}`, ordem, page, perPage: 101, filtersIn, isRestNode: this.isRestNode }
          this.getExternal(externalRequest)
        }
      })
    },
    async update({ dTable, allRegs = false, async = false, options: { sortBy: sort, sortDesc: desc, itemsPerPage, page: pageIndex } }) {
      if (pageIndex) dTable.page = pageIndex
      if (itemsPerPage) dTable.itemsPerPage = itemsPerPage
      if (sort) dTable.order.by = sort.length > 0 ? sort[0] : ''
      if (desc !== null) dTable.order.desc = desc

      const { query, register, order = {by: 'ID', desc: false}, page = 1, itemsPerPage: perPage } = dTable
      // console.info('dTable', dTable);
      const ordem = `${order.by} ${order.by && order.desc ? 'DESC' : ''}`
      const filtersIn = [...this.computedFiltersProcessed.filter(f => f.selecteds.length > 0)]
      const externalRequest = { 
        query, 
        idField: "ID", 
        register: `report${register}`, 
        ordem, 
        page,
        perPage: 101,
        nextPage: true,
        search: this.searchInputs[register],
        fieldsToSearch: dTable.headers.filter(x => x.searchable).map(x => x.searchableContent ||x.value),
        fieldsToMark: dTable.headers.filter((x) => x.searchable && x.searchableContent).map(({searchableContent, value}) => ({ searchableContent, value })),
        filtersIn,
        allRegs,
        async, 
        isRestNode: this.isRestNode
      }
      if (async) {
        await this.getExternal(externalRequest)
      } else {
        this.getExternal(externalRequest)
      }
    },
    async getAll({dTable}) {
      const options = { sortBy: [dTable.order.by], sortDesc: dTable.order.desc, page: 1 }

      await this.update({dTable, async: true, allRegs: true, options})

      const items = (this.searchInputs[dTable.register] && this.searchInputs[dTable.register].length > 0) || (this.computedFiltersProcessed.find(cp => cp.selecteds.length > 0)) ? 
                    this.registers[`report${dTable.register}FilteredAll`] : 
                    this.registers[`report${dTable.register}All`] || []

      return items
    },
    async exportXlsx({dTable}) {
      this.setLoading({stats: true, message: 'Exportando excel'})
      const headers = dTable.headers.filter(h => h.export)
      
      if (!headers || headers.length === 0) {
        // this.$toast.error('Esta tabela não possui campos exportáveis.');
        this.showToast({ message: 'Esta tabela não possui campos exportáveis.', color: "error" });

        return
      }

      const header = headers.map(h => h.text);
      const itemsRegistereds = await this.getAll({dTable})
      
      if (!itemsRegistereds || itemsRegistereds.length === 0) {
        // this.$toast.error('Nenhum item a ser exportado.');
        this.showToast({ message: 'Nenhum item a ser exportado.', color: "error" });

        
        return
      }

      const items = itemsRegistereds.map(item => 
        headers.reduce((acc, header) => 
          ({...acc, [header.text]: (typeof item[header.value] === 'string') ? item[header.value].split('<em>').join('').split('</em>').join('') : item[header.value]}), 
          {}
        )
      )
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(items, { header });

      // adiciona as fórmulas em formato excel para as células das colunas que possuem essa configuração
      items.slice(1).forEach((_, idx) => {
        headers.forEach((header, i) => {
          if (!header.xlsxFormula)
            return
          
          const cellKey = `${String.fromCharCode(65 + i)}${idx + 2}`
          try {
            ws[cellKey].f = header.xlsxFormula.trim().replaceAll('x', `${idx + 2}`)
          } catch (err) {
            console.error(err)
          }
        })
      })
      this.setLoading({stats: false})
      this.showToast({message:"Arquivo exportado com sucesso!", color: "success"})

      XLSX.utils.book_append_sheet(wb, ws, `Sheet`)

      const exportFileName = `${dTable.title}.xlsx`;
      XLSX.writeFile(wb, exportFileName)
    },
  },
  computed: {
    ...registersState(["registers", "counters", 'loading']),
    ...mapState(["companySelected"]),
    ...authState(["user"]),
    computedValorVendido() {
      const valor = this.totalize.find(t => t.label === "VALOR VENDIDO")
      return valor ? valor.value : 0;
    },
    computedMetaTotal() {
      const meta = this.totalize.find(t => t.label === 'META')
      return meta ? meta.value : 0;
    },
    computedKpiCharts() {
      let kpiCharts = {};
      if (
        ["ore"].includes(
          this.companySelected && this.companySelected.groupCompany
            ? this.companySelected.groupCompany
            : ""
        )
      ) {

        this.computedDataTables.map((dTable) => {
          if (dTable.register.includes("venda_meta_report")) {
            const meta = this.totalize.find(t => t.label === 'META')
            const valor = this.totalize.find(t => t.label === "VALOR VENDIDO")
            const metaTotal = meta ? meta.value : 0;
            const valorTotal = valor ? valor.value : 0;

            // const performance = this.items.reduce((acc, d) => { return acc + d['PERCENTUAL_META_ATINGIDA'] }, 0)
            const saldoTotal = valorTotal - metaTotal;

            const performancePerCent = valorTotal ? valorTotal / metaTotal : 0;

            // (data) =>{ const result = (data.reduce((acc,{VALOR_VENDIDO}) => acc +(VALOR_VENDIDO),0))/(data.reduce((acc,{META}) => acc +(META),0)); return result > 100 ? 100 : result }
            kpiCharts[dTable.register] = {
              metaTotal: {
                valueNumber: metaTotal,
                value: new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(metaTotal),
                title: "Meta",
              },
              valorTotal: {
                valueNumber: valorTotal,
                value: new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(valorTotal),
                title: "Venda",
              },
              performance: {
                valueNumber: performancePerCent,
                value: new Intl.NumberFormat("pt-BR", {
                  style: "percent",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(performancePerCent),
                title: "Performance",
              },
              saldoTotal: {
                valueNumber: saldoTotal,
                value: new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(saldoTotal),
                title: "Saldo",
              },
            };
          }
        });
      }
      
      return kpiCharts;
    },
    isFiltered() {
      return Object.values(this.filtersMounted).filter(x => x != null).length > 0
    },
    items() {
      const register = (this.isFiltered || this.isSearched) ? `report${this.props.register}Filtered` : `report${this.props.register}`
      return this.registers[register] || []
    },
    isSearched() {
      const register = this.props.register
      return (this.searchInputs[register] && this.searchInputs[register].length > 0) || (this.computedFiltersProcessed.find(cp => cp.selecteds.length > 0))
    },
    computedFiltersAsync() {
      if (!this.props.filtersAsync || this.props.filtersAsync.length == 0) return []
      const filters = this.props.filtersAsync
        .filter(x => x.filterIndex)
        .map(x => {
          x.filterValue = x.value
          if (x.source == 'customautocomplete') {
            x.asyncSearch = {
              collection: x.collection,
              orderBy: (x.orderBy) ? JSON.parse(x.orderBy) : [], 
              filters: (x.filters) ? JSON.parse(x.filters) : [], 
              orFilters: (x.orFilters) ? JSON.parse(x.orFilters) : [], 
              distinct: x.distinct,
              disableIntFilters: x.disableIntFilters
            }
          }
          return x
        })
        .sort((a,b) => a.filterIndex-b.filterIndex);
      return filters
    },
    props() {
      return this.dataTables && this.dataTables[0]
    },
    headers() {
      return this.props.headers
    },
    computedEmptyRegisters() {
      let items = {}
      for (const dTable of this.computedDataTables) {
        const registers = (!this.loading[`report${dTable.register}`] ? (this.searchInputs[dTable.register] && this.searchInputs[dTable.register].length > 0) || (this.computedFiltersProcessed.find(cp => cp.selecteds.length > 0)) ? 
                  this.registers[`report${dTable.register}Filtered`] : 
                  this.registers[`report${dTable.register}`] || [] : [])
        items[dTable.register] = registers.length === 0
      }
      return items
    },
    computedSearchEnableds() {
      return this.searchEnableds;
    },
    computedConfigsShowed() {
      return this.configsShowed;
    },
    computedHeadersShowed() {
      return this.headersShowed
    },
    computedDataTables() {
      return this.dataTablesProcessed.map((dTable) => {
        return {...dTable};
      });
    },
    computedFiltersProcessed() {
      return this.filtersProcessed
    },
    computedHasFiltersApplied() { 
      return this.computedFiltersProcessed.some(cp => cp.selecteds.length > 0)
    }
  },
  async created() {
    this.initRegisters();
    this.searchEnableds = {...Object.assign({}, ...this.dataTables.map((dt) => ({[dt.register]: false})))};
    this.configsShowed = this.searchEnableds; //{...Object.assign({}, ...this.dataTables.map(dt=>  ( {[dt.register]: false} ))) }
    this.headersShowed = {
      ...Object.assign({}, 
      ...this.dataTables.map((dt) => 
        ({[dt.register]: Object.assign({}, ...dt.headers.map((h) => ({[h.value]: h.showable})))})
      )
    )};
  },
  setup(){
    const isOpenRef = ref(false);
    const setOpen = (state) => (isOpenRef.value = state);

    const event = ref();
    const isPopOverRef = ref(false);
    const showPopOver = (state, ev) => {
      isPopOverRef.value = state
      event.value = ev
    };

    return { filterOutline, isOpenRef, menu, setOpen, sadOutline, funnelOutline, close, settingsOutline, ellipsisVertical, downloadOutline, isPopOverRef, showPopOver, event, pieChartOutline };
  },
};
</script>

<style scoped>
  .ion-page ion-footer :deep(ion-card-header) ion-item {
    min-height: 0;
    height: 25px;
  }
  .ion-page ion-footer :deep(ion-card-header) ion-item::part(native) {
    min-height: 0!important;
  }
  .ion-page ion-footer ion-card-subtitle, .ion-page ion-footer ion-label {
    font-size: 0.65em;
    margin: 0;
    padding: 5px 0;
  }
  .filters-applied * {
    margin: 0;
    padding: 0;
    font-size: .75em;
  }
  .empty-data-table {
    height: 100%;
    text-align: center;
  }
</style>